module.exports = __webpack_public_path__ + "img/freespin2_multiplier20.314434b1.png";